import appsettings from "../../config/appsettings.json";
import envOverrides from "./env.json";
import type { DeepPartial, IdentityClientSettings, RuntimeEnvOverrides } from "./types";

const isPresent = (value: unknown): boolean =>
  value !== undefined && value !== null && value !== "";

const mergeDeep = <T extends object>(base: T, ...parts: Array<DeepPartial<T> | undefined>): T => {
  const result = { ...base } as T;

  for (const part of parts) {
    if (!part) continue;

    for (const key of Object.keys(part) as Array<keyof T>) {
      const value = part[key];
      if (!isPresent(value)) continue;

      const current = result[key];
      if (
        typeof value === "object" &&
        !Array.isArray(value) &&
        typeof current === "object" &&
        current !== null &&
        !Array.isArray(current)
      ) {
        result[key] = mergeDeep(current as object, value as object) as T[keyof T];
      } else {
        result[key] = value as T[keyof T];
      }
    }
  }

  return result;
};

const runtimeOverrides: RuntimeEnvOverrides | undefined =
  typeof window !== "undefined" ? window.__env : undefined;

const settings = mergeDeep(
  appsettings as IdentityClientSettings,
  envOverrides as DeepPartial<IdentityClientSettings>,
  runtimeOverrides as DeepPartial<IdentityClientSettings> | undefined
);

export default settings;
